/**
 * Created by asiulik on 15.05.2018.
 */

define(['jquery', './parketFiltersConfig', 'sideNav'], function($, FiltersConfig){

    function ParketFiltersNav(layoutIstance){
        this.layoutIstance = layoutIstance;
    }

    ParketFiltersNav.prototype.init = function(){
        this.$filtersNav = $(FiltersConfig.filterSideNavTriggerSelector);

        if(!this.$filtersNav.length) return;

        this.sideNavCreated = false;

        this.initNav();
        this.bindEvents();

    };

    ParketFiltersNav.prototype.initNav = function(){

        if(this.layoutIstance.isDesktopView()) return;
        this.createSideNavInstance();

    };

    ParketFiltersNav.prototype.createSideNavInstance = function(){

        if(this.sideNavCreated) return;

        this.$filtersNav.sideNav({
            edge: 'left',
            closeOnClick: true
        });

        this.sideNavCreated = true;

    };

    ParketFiltersNav.prototype.destroySideNavInstance = function(){

        if(this.sideNavCreated){
            this.$filtersNav.sideNav('destroy');
            this.sideNavCreated = undefined;
        }

    };

    ParketFiltersNav.prototype.bindEvents = function(){

        var _this = this;

        this.layoutIstance.on('reload', function(){

            _this.layoutIstance.isDesktopView() ?
                _this.destroySideNavInstance() : _this.createSideNavInstance();

        })

    };

    return ParketFiltersNav;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/parketFilters/parketFiltersNav.js